import { render, staticRenderFns } from "./aboutUS.vue?vue&type=template&id=11ca5828&scoped=true&"
import script from "./aboutUS.vue?vue&type=script&lang=js&"
export * from "./aboutUS.vue?vue&type=script&lang=js&"
import style0 from "./aboutUS.vue?vue&type=style&index=0&id=11ca5828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca5828",
  null
  
)

export default component.exports